import React, { useState, useContext, useEffect } from 'react';
import axios from 'axios';
import UserContext from '../../contexts/UserContext';
import { formatMoney } from '../../utils/currency';
import { useNavigate, useLocation } from 'react-router-dom';
import authenticate from '../../utils/Authenticate';
import { n2 } from '../../utils/fmt';

const CreatePurchaseOrder = () => {
    const { user, setUser } = useContext(UserContext);
    const navigate = useNavigate();
     const location = useLocation();
    
    // Form state
    const [formData, setFormData] = useState({
        date: new Date().toISOString().split('T')[0], // Today's date by default
        supplierId: '',
        deliveryDate: '',
        remarks: ''
    });
    
    // Dropdown options
    const [zones, setZones] = useState([]);
    const [suppliers, setSuppliers] = useState([]);
    const [loadingZones, setLoadingZones] = useState(true);
    const [loadingSuppliers, setLoadingSuppliers] = useState(true);
    const [requests, setRequests] = useState('');
    
    // Multi-zone structure
    const [zoneData, setZoneData] = useState([
        {
            id: 1,
            zoneId: '',
            poIncharge: '',
            items: [
                {
                    id: 1,
                    itemId: '',
                    itemName: '',
                    quantity: '',
                    unit: '',
                    pricePerUnit: '',
                    searchTerm: '',
                    searchResults: [],
                    searchLoading: false,
                    selectedItem: null
                }
            ]
        }
    ]);

useEffect(() => {
    const menuData = location.state?.rawMaterials;
    const items = mapItemsFromMultipleMenus(menuData);
    console.log("_hile", location.state?.zone);

    // If items is null or empty, use a default blank item
    const updatedItems = items && items.length > 0
        ? items.map((item, index) => ({
            id: index + 1,
            ...item,
            searchResults: [],
            searchLoading: false,
        }))
        : [
            {
                id: 1,
                itemId: '',
                itemName: '',
                quantity: '',
                unit: '',
                pricePerUnit: '',
                searchTerm: '',
                searchResults: [],
                searchLoading: false,
                selectedItem: null
            }
        ];

    setZoneData(prev => [
        {
            ...prev[0],
            zoneId: location.state?.zone.id || '',
            items: updatedItems
        }
    ]);
}, [location.state]);



//       useEffect(() => {
//     const initialize = async () => {
//       if (!user) {
//         await authenticate(setUser, navigate);
//       }

//       if (user) {
//           setRequests(location.state);
//       }
//     };

//     initialize();
//   }, [user, location.state, navigate, setUser]);

    //data mapping helper function
function mapItemsFromMultipleMenus(menusArray) {
    const itemMap = {};

    if (!menusArray) {
        return
    }

    for (const menu of menusArray) {
        if (!menu?.dishes) continue;

        for (const dish of menu.dishes) {
            for (const itemEntry of dish.item) {
                const item = itemEntry.dish;
                const quantity = itemEntry.quantity || 0;

                if (!item || !item._id) continue;

                if (!itemMap[item._id]) {
                    itemMap[item._id] = {
                        itemId: item._id,
                        itemName: item.name,
                        quantity: n2(quantity),
                        unit: item.unit,
                        pricePerUnit: n2(item.basePrice || 0),
                        searchTerm: item.name,
                        selectedItem: {
                          basePrice: item.basePrice || 0,
                          category: item.category || 'item',
                          createdAt: item.createdAt,
                          name: item.name,
                          purchaseType: item.purchaseType || 'Supplier',
                          unit: item.unit,
                          updatedAt: item.updatedAt || "2024-06-08T16:36:10.841Z",
                          __v: item._v,
                          _id: item._id
                        }
                    };
                } else {
                    itemMap[item._id].quantity = n2(itemMap[item._id].quantity + quantity);
                }
            }
        }
    }
    

    return Object.values(itemMap);
}


    
    // Keyboard navigation states
    const [selectedSearchIndex, setSelectedSearchIndex] = useState({});
    const [activeSearch, setActiveSearch] = useState({});
    
    const [notification, setNotification] = useState({ message: '', type: '' });
    const [submitting, setSubmitting] = useState(false);

    // Fetch zones and suppliers on component mount
    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                // Fetch zones
                setLoadingZones(true);
                const zonesResponse = await axios.get(`${process.env.REACT_APP_API_URI}/api/zones/getAll`, { withCredentials: true });
                console.log(zonesResponse);
                setZones(zonesResponse.data.data);
                
                // Fetch suppliers
                setLoadingSuppliers(true);
                const suppliersResponse = await axios.get(`${process.env.REACT_APP_API_URI}/api/supplier/getAll`, { withCredentials: true });
                console.log(suppliersResponse);
                setSuppliers(suppliersResponse.data.data);
                
            } catch (error) {
                console.error('Error fetching initial data:', error);
                setNotification({ message: 'Error loading zones or suppliers', type: 'error' });
            } finally {
                setLoadingZones(false);
                setLoadingSuppliers(false);
            }
        };

        fetchInitialData();
    }, []);

    useEffect(() => {
        async function startup() {
            if (!user) {
                await authenticate(setUser, navigate);
            }
        }
        startup();
    }, [user, navigate, setUser]);

    // Handle form data changes
    const handleFormChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    // Handle zone selection
    const handleZoneChange = (zoneIndex, zoneId) => {
        const updatedZoneData = [...zoneData];
        updatedZoneData[zoneIndex].zoneId = zoneId;
        setZoneData(updatedZoneData);
    };

    // Add new zone
    const handleAddZone = () => {
        const newZone = {
            id: zoneData.length + 1,
            zoneId: '',
            poIncharge: '',
            items: [
                {
                    id: 1,
                    itemId: '',
                    itemName: '',
                    quantity: '',
                    unit: '',
                    pricePerUnit: '',
                    searchTerm: '',
                    searchResults: [],
                    searchLoading: false,
                    selectedItem: null
                }
            ]
        };
        setZoneData([...zoneData, newZone]);
    };

    // Handle PO Incharge change
    const handlePoInchargeChange = (zoneIndex, value) => {
        const updatedZoneData = [...zoneData];
        updatedZoneData[zoneIndex].poIncharge = value;
        setZoneData(updatedZoneData);
    };

    // Remove zone
    const handleRemoveZone = (zoneIndex) => {
        if (zoneData.length > 1) {
            const updatedZoneData = zoneData.filter((_, index) => index !== zoneIndex);
            setZoneData(updatedZoneData);
        }
    };

    // Handle keyboard navigation for item search
    const handleKeyDown = (e, zoneIndex, itemIndex) => {
        const searchKey = `${zoneIndex}-${itemIndex}`;
        const isActive = activeSearch[searchKey];
        const results = zoneData[zoneIndex].items[itemIndex].searchResults || [];
        
        if (!isActive || results.length === 0) return;

        switch (e.key) {
            case 'ArrowDown':
                e.preventDefault();
                setSelectedSearchIndex(prev => ({
                    ...prev,
                    [searchKey]: prev[searchKey] < results.length - 1 
                        ? prev[searchKey] + 1 
                        : 0
                }));
                break;
            case 'ArrowUp':
                e.preventDefault();
                setSelectedSearchIndex(prev => ({
                    ...prev,
                    [searchKey]: prev[searchKey] > 0 
                        ? prev[searchKey] - 1 
                        : results.length - 1
                }));
                break;
            case 'Enter':
                e.preventDefault();
                const currentIndex = selectedSearchIndex[searchKey];
                if (currentIndex >= 0) {
                    handleSelectItem(zoneIndex, itemIndex, results[currentIndex]);
                }
                break;
            case 'Escape':
                e.preventDefault();
                setActiveSearch(prev => ({ ...prev, [searchKey]: false }));
                setSelectedSearchIndex(prev => ({ ...prev, [searchKey]: -1 }));
                break;
        }
    };

    // Handle item search
    const handleItemSearch = async (zoneIndex, itemIndex, searchValue) => {
        const updatedZoneData = [...zoneData];
        updatedZoneData[zoneIndex].items[itemIndex].searchTerm = searchValue;
        
        const searchKey = `${zoneIndex}-${itemIndex}`;
        setActiveSearch(prev => ({ ...prev, [searchKey]: true }));
        setSelectedSearchIndex(prev => ({ ...prev, [searchKey]: -1 }));
        
        try {
            updatedZoneData[zoneIndex].items[itemIndex].searchLoading = true;
            setZoneData(updatedZoneData);
            
            const response = await axios.get(
                `${process.env.REACT_APP_API_URI}/api/findItems`,
                {
                    params: { q: searchValue },
                },
                { withCredentials: true }
            );
            console.log('Search results:', response);
            updatedZoneData[zoneIndex].items[itemIndex].searchResults = response.data;
            updatedZoneData[zoneIndex].items[itemIndex].searchLoading = false;
            setZoneData(updatedZoneData);
            
        } catch (error) {
            console.error('Error searching items:', error);
            updatedZoneData[zoneIndex].items[itemIndex].searchLoading = false;
            setZoneData(updatedZoneData);
        }
    };

    // Handle item selection from search results
    const handleSelectItem = (zoneIndex, itemIndex, selectedItem) => {
        const updatedZoneData = [...zoneData];
        updatedZoneData[zoneIndex].items[itemIndex] = {
            ...updatedZoneData[zoneIndex].items[itemIndex],
            itemId: selectedItem._id,
            itemName: selectedItem.name,
            unit: selectedItem.unit,
            searchTerm: selectedItem.name,
            searchResults: [],
            selectedItem: selectedItem
        };
        setZoneData(updatedZoneData);
        
        // Clear search states
        const searchKey = `${zoneIndex}-${itemIndex}`;
        setActiveSearch(prev => ({ ...prev, [searchKey]: false }));
        setSelectedSearchIndex(prev => ({ ...prev, [searchKey]: -1 }));
    };

    // Handle item field changes
    const handleItemChange = (zoneIndex, itemIndex, field, value) => {
        const updatedZoneData = [...zoneData];
        updatedZoneData[zoneIndex].items[itemIndex][field] = value;
        setZoneData(updatedZoneData);
    };

    // Add new item to a zone
    const handleAddItem = (zoneIndex) => {
        const updatedZoneData = [...zoneData];
        const newItem = {
            id: updatedZoneData[zoneIndex].items.length + 1,
            itemId: '',
            itemName: '',
            quantity: '',
            unit: '',
            pricePerUnit: '',
            searchTerm: '',
            searchResults: [],
            searchLoading: false,
            selectedItem: null
        };
        updatedZoneData[zoneIndex].items.push(newItem);
        setZoneData(updatedZoneData);
    };

    // Remove item from a zone
    const handleRemoveItem = (zoneIndex, itemIndex) => {
        const updatedZoneData = [...zoneData];
        if (updatedZoneData[zoneIndex].items.length > 1) {
            updatedZoneData[zoneIndex].items = updatedZoneData[zoneIndex].items.filter((_, index) => index !== itemIndex);
            setZoneData(updatedZoneData);
        }
    };

    // Calculate total for a zone
    const calculateZoneTotal = (zone) => {
        return zone.items.reduce((total, item) => {
            const itemTotal = item.quantity && item.pricePerUnit 
                ? parseFloat(item.quantity) * parseFloat(item.pricePerUnit)
                : 0;
            return total + itemTotal;
        }, 0);
    };

    // Calculate grand total
    const calculateGrandTotal = () => {
        return zoneData.reduce((grandTotal, zone) => {
            return grandTotal + calculateZoneTotal(zone);
        }, 0);
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        console.log(zoneData);
        
        e.preventDefault();
        
        // Validation
        if (!formData.supplierId || !formData.deliveryDate) {
            setNotification({ message: 'Please fill in all required fields', type: 'error' });
            return;
        }

        // Validate zones
        const invalidZones = zoneData.some(zone => !zone.zoneId);
        if (invalidZones) {
            setNotification({ message: 'Please select zones for all zone sections', type: 'error' });
            return;
        }

        // Validate items
        const invalidItems = zoneData.some(zone => 
            zone.items.some(item => 
                !item.itemId || !item.quantity || !item.pricePerUnit || 
                parseFloat(item.quantity) <= 0 || parseFloat(item.pricePerUnit) <= 0
            )
        );

        if (invalidItems) {
            setNotification({ message: 'Please complete all item details with valid quantities and prices', type: 'error' });
            return;
        }

        try {
            setSubmitting(true);
            
            const purchaseOrderData = {
                date: formData.date,
                supplierId: formData.supplierId,
                deliveryDate: formData.deliveryDate,
                remarks: formData.remarks,
                zones: zoneData.map(zone => ({
                    zoneId: zone.zoneId,
                    poIncharge: zone.poIncharge,
                    items: zone.items.map(item => ({
                        itemId: item.itemId,
                        itemName: item.itemName,
                        quantity: parseFloat(item.quantity),
                        unit: item.unit,
                        pricePerUnit: parseFloat(item.pricePerUnit),
                        totalPrice: parseFloat(item.quantity) * parseFloat(item.pricePerUnit)
                    }))
                }))
            };

            const response = await axios.post(
                `${process.env.REACT_APP_API_URI}/api/po/add`,
                purchaseOrderData,
                { withCredentials: true }
            );

            setNotification({ message: 'Purchase Order Created Successfully', type: 'success' });
            
            // Reset form
            setFormData({
                date: new Date().toISOString().split('T')[0],
                supplierId: '',
                deliveryDate: '',
                remarks: ''
            });
            setZoneData([{
                id: 1,
                zoneId: '',
                poIncharge: '',
                items: [{
                    id: 1,
                    itemId: '',
                    itemName: '',
                    quantity: '',
                    unit: '',
                    pricePerUnit: '',
                    searchTerm: '',
                    searchResults: [],
                    searchLoading: false,
                    selectedItem: null
                }]
            }]);

        } catch (error) {
            console.error('Error creating purchase order:', error);
            if (error.response && error.response.status === 409) {
                setNotification({ message: 'Purchase Order already exists for this configuration', type: 'error' });
            } else {
                setNotification({ message: 'An error occurred while creating the Purchase Order', type: 'error' });
            }
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <>
            <div className="wrapper">
                <div className="w-full">
                    <h2 className="text-base font-bold bg-lime-800 text-white p-3 py-4 text-center">Create Purchase Order</h2>
                    {notification.message && (
                        <div className={`p-2 mb-4 ${notification.type === 'error' ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700'}`}>
                            {notification.message}
                        </div>
                    )}
                </div>
                
                <div className="max-w-7xl mx-auto">
                    <form onSubmit={handleSubmit} className="px-6 pt-4 pb-6 mb-4">
                        {/* Header Information */}
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
                            {/* Date */}
                            <div>
                                <label className="block text-gray-700 text-sm font-semibold mb-2">
                                    Order Date *
                                </label>
                                <input
                                    type="date"
                                    name="date"
                                    value={formData.date}
                                    onChange={handleFormChange}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-lime-500 focus:border-transparent text-sm"
                                    required
                                />
                            </div>

                            {/* Supplier Selection */}
                            <div>
                                <label className="block text-gray-700 text-sm font-semibold mb-2">
                                    Select Supplier *
                                </label>
                                <select
                                    name="supplierId"
                                    value={formData.supplierId}
                                    onChange={handleFormChange}
                                    disabled={loadingSuppliers}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-lime-500 focus:border-transparent text-sm"
                                    required
                                >
                                    <option value="">
                                        {loadingSuppliers ? 'Loading suppliers...' : 'Choose a supplier'}
                                    </option>
                                    {suppliers.map((supplier) => (
                                        <option key={supplier._id} value={supplier._id}>
                                            {supplier.company}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            {/* Delivery Date */}
                            <div>
                                <label className="block text-gray-700 text-sm font-semibold mb-2">
                                    Delivery Date *
                                </label>
                                <input
                                    type="date"
                                    name="deliveryDate"
                                    value={formData.deliveryDate}
                                    onChange={handleFormChange}
                                    min={formData.date}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-lime-500 focus:border-transparent text-sm"
                                    required
                                />
                            </div>
                        </div>

                        {/* Multi-Zone Sections */}
                        <div className="mb-6">
                            <h3 className="text-lg font-bold text-gray-800 mb-4 pb-2 border-b border-gray-200">
                                Zone-wise Order Items
                            </h3>

                            {zoneData.map((zone, zoneIndex) => (
                                <div key={zone.id} className="mb-6 border border-lime-300 rounded-lg bg-gradient-to-r from-lime-50 to-green-50">
                                    {/* Zone Header */}
                                    <div className="bg-lime-100 px-4 py-3 border-b border-lime-200">
                                        <div className="flex items-center justify-between">
                                            <h4 className="text-lg font-semibold text-gray-800">Zone {zoneIndex + 1}</h4>
                                            {zoneData.length > 1 && (
                                                <button
                                                    type="button"
                                                    onClick={() => handleRemoveZone(zoneIndex)}
                                                    className="bg-red-500 hover:bg-red-600 text-white text-xs font-semibold py-1 px-3 rounded-full transition-colors"
                                                >
                                                    Remove
                                                </button>
                                            )}
                                        </div>

                                        {/* Zone Selection */}
                                        <div className="mt-3">
                                            <select
                                                value={zone.zoneId}
                                                onChange={(e) => handleZoneChange(zoneIndex, e.target.value)}
                                                disabled={loadingZones}
                                                className="w-full md:w-1/2 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-lime-500 text-sm"
                                                required
                                            >
                                                <option value="">
                                                    {loadingZones ? 'Loading zones...' : 'Choose a zone'}
                                                </option>
                                                {zones.map((zoneOption) => (
                                                    <option key={zoneOption._id} value={zoneOption._id}>
                                                        {zoneOption.desc}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        {/* ADD PO INCHARGE INPUT HERE */}
                                        <div className="mt-3">
                                            <input
                                                type="text"
                                                value={zone.poIncharge}
                                                onChange={(e) => handlePoInchargeChange(zoneIndex, e.target.value)}
                                                placeholder="PO Incharge Name"
                                                className="w-full md:w-1/2 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-lime-500 text-sm"
                                            />
                                        </div>
                                    </div>

                                    {/* Items Table-like Layout */}
                                    <div className="p-4">
                                        <div className="space-y-2">
                                            {/* Table Header */}
                                            <div className="grid grid-cols-12 gap-2 text-xs font-semibold text-gray-600 bg-gray-100 px-3 py-2 rounded">
                                                <div className="col-span-4">Item Name</div>
                                                <div className="col-span-2">Quantity</div>
                                                <div className="col-span-2">Unit</div>
                                                <div className="col-span-2">Price/Unit</div>
                                                <div className="col-span-1">Total</div>
                                                <div className="col-span-1">Action</div>
                                            </div>

                                            {/* Items Rows */}
                                            {zone.items.map((item, itemIndex) => (
                                                <div key={item.id} className="grid grid-cols-12 gap-2 items-center bg-white p-3 rounded border border-gray-200 hover:shadow-sm transition-shadow">
                                                    {/* Item Name Search */}
                                                    <div className="col-span-4 relative">
                                                        <input
                                                            type="text"
                                                            value={item.searchTerm}
                                                            onChange={(e) => handleItemSearch(zoneIndex, itemIndex, e.target.value)}
                                                            onKeyDown={(e) => handleKeyDown(e, zoneIndex, itemIndex)}
                                                            onFocus={() => {
                                                                const searchKey = `${zoneIndex}-${itemIndex}`;
                                                                setActiveSearch(prev => ({ ...prev, [searchKey]: true }));
                                                            }}
                                                            onBlur={() => {
                                                                setTimeout(() => {
                                                                    const searchKey = `${zoneIndex}-${itemIndex}`;
                                                                    setActiveSearch(prev => ({ ...prev, [searchKey]: false }));
                                                                    setSelectedSearchIndex(prev => ({ ...prev, [searchKey]: -1 }));
                                                                }, 200);
                                                            }}
                                                            placeholder="Search items..."
                                                            className="w-full px-2 py-1.5 border border-gray-300 rounded text-sm focus:outline-none focus:ring-1 focus:ring-lime-500"
                                                            required
                                                        />
                                                        {item.searchLoading && (
                                                            <div className="absolute right-2 top-2">
                                                                <div className="animate-spin h-3 w-3 border border-gray-400 border-t-transparent rounded-full"></div>
                                                            </div>
                                                        )}
                                                        
                                                        {/* Search Results Dropdown */}
                                                        {item.searchResults.length > 0 && activeSearch[`${zoneIndex}-${itemIndex}`] && (
                                                            <div className="absolute z-50 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-32 overflow-y-auto">
                                                                {item.searchResults.map((searchItem, resultIndex) => (
                                                                    <div 
                                                                        key={searchItem._id} 
                                                                        className={`px-3 py-2 cursor-pointer text-sm border-b border-gray-100 last:border-b-0 ${
                                                                            resultIndex === selectedSearchIndex[`${zoneIndex}-${itemIndex}`] 
                                                                                ? 'bg-lime-100' 
                                                                                : 'hover:bg-gray-50'
                                                                        }`}
                                                                        onClick={() => handleSelectItem(zoneIndex, itemIndex, searchItem)}
                                                                        onMouseEnter={() => {
                                                                            const searchKey = `${zoneIndex}-${itemIndex}`;
                                                                            setSelectedSearchIndex(prev => ({ ...prev, [searchKey]: resultIndex }));
                                                                        }}
                                                                    >
                                                                        <div className="font-medium">{searchItem.name}</div>
                                                                        <div className="text-xs text-gray-500">({searchItem.unit})</div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                    </div>

                                                    {/* Quantity */}
                                                    <div className="col-span-2">
                                                        <input
                                                            type="number"
                                                            value={item.quantity}
                                                            onChange={(e) => handleItemChange(zoneIndex, itemIndex, 'quantity', e.target.value)}
                                                            placeholder="Qty"
                                                            min="0"
                                                            step="any"
                                                            onWheel={(e) => e.target.blur()}
                                                            className="w-full px-2 py-1.5 border border-gray-300 rounded text-sm focus:outline-none focus:ring-1 focus:ring-lime-500"
                                                            required
                                                        />
                                                    </div>

                                                    {/* Unit */}
                                                    <div className="col-span-2">
                                                        <input
                                                            type="text"
                                                            value={item.unit}
                                                            readOnly
                                                            className="w-full px-2 py-1.5 border border-gray-200 rounded text-sm bg-gray-50 text-gray-600"
                                                            placeholder="Unit"
                                                        />
                                                    </div>

                                                    {/* Price Per Unit */}
                                                    <div className="col-span-2">
                                                        <input
                                                            type="number"
                                                            value={item.pricePerUnit}
                                                            onChange={(e) => handleItemChange(zoneIndex, itemIndex, 'pricePerUnit', e.target.value)}
                                                            placeholder="Price"
                                                            min="0"
                                                            step="any"
                                                            onWheel={(e) => e.target.blur()}
                                                            className="w-full px-2 py-1.5 border border-gray-300 rounded text-sm focus:outline-none focus:ring-1 focus:ring-lime-500"
                                                            required
                                                        />
                                                    </div>

                                                    {/* Total */}
                                                    <div className="col-span-1 text-right">
                                                        <span className="text-xs font-semibold text-gray-700">
                                                            {item.quantity && item.pricePerUnit
                                                                ? formatMoney(user, parseFloat(item.quantity) * parseFloat(item.pricePerUnit), 0)
                                                                : formatMoney(user, 0, 0)
                                                            }
                                                        </span>
                                                    </div>

                                                    {/* Remove Button */}
                                                    <div className="col-span-1 text-center">
                                                        {zone.items.length > 1 && (
                                                            <button
                                                                type="button"
                                                                onClick={() => handleRemoveItem(zoneIndex, itemIndex)}
                                                                className="text-red-500 hover:text-red-700 text-xs font-semibold"
                                                                title="Remove Item"
                                                            >
                                                                ✕
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>

                                        {/* Add Item and Zone Total */}
                                        <div className="flex justify-between items-center mt-4 pt-3 border-t border-gray-200">
                                            <button
                                                type="button"
                                                onClick={() => handleAddItem(zoneIndex)}
                                                className="bg-green-500 hover:bg-green-600 text-white text-sm font-semibold py-2 px-4 rounded-md transition-colors"
                                            >
                                                + Add Item
                                            </button>
                                            <div className="text-right">
                                                <span className="text-sm font-bold text-gray-800">
                                                    Zone Total: {formatMoney(user, calculateZoneTotal(zone))}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}

                            {/* Add Zone Button - Moved to bottom */}
                            <div className="text-center mt-6">
                                <button
                                    type="button"
                                    onClick={handleAddZone}
                                    className="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-3 px-6 rounded-lg transition-colors shadow-md"
                                >
                                    + Add Another Zone
                                </button>
                            </div>
                        </div>

                        {/* Grand Total */}
                        <div className="mb-6 p-4 bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-lg">
                            <div className="text-center">
                                <h3 className="text-xl font-bold text-blue-800">
                                    Grand Total: {formatMoney(user, calculateGrandTotal())}
                                </h3>
                            </div>
                        </div>

                        {/* Remarks */}
                        <div className="mb-6">
                            <label className="block text-gray-700 text-sm font-semibold mb-2">
                                Remarks
                            </label>
                            <textarea
                                name="remarks"
                                value={formData.remarks}
                                onChange={handleFormChange}
                                rows={3}
                                placeholder="Any notes or remarks for this purchase order..."
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-lime-500 focus:border-transparent text-sm resize-none"
                            />
                        </div>

                        {/* Submit Button */}
                        <div className="flex items-center justify-center">
                            <button
                                type="submit"
                                disabled={submitting}
                                className="bg-lime-600 hover:bg-lime-700 text-white font-bold py-3 px-8 rounded-full focus:outline-none focus:ring-4 focus:ring-lime-300 transition-all disabled:opacity-50 shadow-lg"
                            >
                                {submitting ? 'Creating Purchase Order...' : 'Create Purchase Order'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
};

export default CreatePurchaseOrder;